// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UseLostWidth$Showside from "./UseLostWidth.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
function use(hasProducts) {
  var match = ViewportContext$Showside.use(undefined);
  var windowHeight = StickyHeaderOffsetProvider$Showside.useAdjustedWindowHeight(undefined);
  var lostWidth = UseLostWidth$Showside.use(hasProducts);
  var width = match.windowSize.width - lostWidth | 0;
  return [width, windowHeight];
}
export { use };
/* UseLostWidth-Showside Not a pure module */